export const buttonGroup = (theme) => ({
    item: {
        active: {
            backgroundColor: theme.colors?.component?.brandLight?.default,
            borderColor: theme.colors?.border?.focus,
            color: theme.colors?.text?.brand,
            hover: { backgroundColor: theme.colors?.component?.brandLight?.hover },
            active: { backgroundColor: theme.colors?.component?.brandLight?.active },
        },
        inactive: {
            backgroundColor: theme.colors?.component?.default,
            borderColor: theme.colors?.border?.control,
            color: theme.colors?.text?.basic?.primary,
            hover: { backgroundColor: theme.colors?.component?.alt?.hover },
            active: { backgroundColor: theme.colors?.component?.alt?.active },
        },
        disabled: {
            backgroundColor: theme.colors?.component?.disabled,
            borderColor: theme.colors?.border?.disabled,
            color: theme.colors?.text?.basic?.disabled,
        },
        focusRing: theme.colors?.effects?.focusRing,
        borderRadius: theme.radii?.sm,
        transition: 'background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease',
    },
});
//# sourceMappingURL=button-group.js.map